import React, {PureComponent} from 'react';
import i18n from '../../utils/i18n';
import {reactRouterParamsType, locationAttributesType} from '../../constants/proptype-validation';

export default class extends PureComponent {
  static displayName = 'PathNotFound';

  static propTypes = {
    params: reactRouterParamsType.isRequired,
    location: locationAttributesType.isRequired
  };

  render() {
    const {
      location: {pathname, state: {originalPathname} = {}},
      params: {splat}
    } = this.props;
    return <div>{i18n.t('errors.unhandledPath', {path: originalPathname || splat || pathname})}</div>;
  }
}
